import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  controllersList:[],
  controllersError: '',
  controllersLoading: false
}

const getters = {
  controllersLoading: state => state.controllersLoading,
  controllersError: state => state.controllersError,
  controllersList: state => state.controllersList
}

const mutations = {
  [types.GET_CONTROLLERS_REQUEST] (state){
    state.controllersLoading = true;
    state.controllersList = [];
    state.controllersError = {};
  },
  [types.GET_CONTROLLERS_SUCCESS] (state, controllers){
    state.controllersLoading = false;
    state.controllersList = controllers;
    state.controllersError = {};
  },
  [types.GET_CONTROLLERS_FAILURE] (state, error){
    state.controllersLoading = false;
    state.controllersList = [];
    state.controllersError = error;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
